// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"5ac43522","164":"dd1d5e60","206":"d9cd9950","787":"b2c3f5bb","834":"d654e807","886":"a6bb227a","927":"375af1ff"}[chunkId] + ".chunk.js";
};